import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { Button } from '@ipc/ipc-components';
import RecalculateTasksSelectionCriteria from './RecalculateTasksSelectionCriteria';
import { getLeftCheckedMailProcessingCenters, getUserRole } from '../../../common/user/redux/selectors/UserDataSelectors';
import { getAssetType } from '../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { tableLoadData } from '../../../common/tables/actions/ListTableActions';
import TableDefinitions from '../../../common/TableDefinitions';
import ListTable from '../../../common/tables/ListTable';
import { getColumns, getData, getIsLoading } from '../redux/selectors/RecalculateTasksSelectors';
import { getGlobalStartDate } from '../../../common/selection-criteria/period/redux/selectors/GlobalPeriodSelectionSelectors';
import { setGlobalStartDateSelectionActionCreator } from '../../../common/selection-criteria/period/redux/actions/GlobalPeriodSelectionActions';
import RecalculateTasksCreate from '../create/containers/RecalculateTasksCreate';

class RecalculateTasksContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResult: false,
      selectedDate: this.props.globalStartDate,
      showCreateModal: false,
    };
    this.createRecalculateTask = this.createRecalculateTask.bind(this);
  }

  onDateChange = (newDate) => {
    this.setState({
      selectedDate: newDate,
    });
    this.props.setGlobalStartDateSelectionActionCreator(newDate);
  }

  onCriteriaApply = () => {
    this.setState({
      showResult: true,
    });

    this.props.tableLoadData(
      { tableId: 'RECALCULATE_TASKS_LIST' },
      this.props.appContext.appContext,
      {
        impcCodes: this.props.checkedMailProcessingCenters,
        inputDate: this.state.selectedDate,
      },
    );
  };

  showCreateFormModal = () => {
    this.setState({
      showCreateModal: true,
    });
  }

  hideCreateFormModal = () => {
    this.setState({
      showCreateModal: false,
    });
  }

  createRecalculateTask() {
    this.setState({
      showCreateModal: true,
    });
  }

  render() {
    const { isLoading, data, columns } = this.props;
    const { showResult, selectedDate, showCreateModal } = this.state;

    return (
      <div>
        <RecalculateTasksSelectionCriteria
          open={data.length === 0}
          title="RECALCULATE TASKS"
          onApply={this.onCriteriaApply}
          selectedDate={selectedDate}
          onDateChange={this.onDateChange}
        />
        <div className="general-content-container">
          {(showResult || data.length > 0) && (
            <div className="full-width">
              {(this.props.userRole.includes('IPC_PALLET_BOX_MANAGER')
                || this.props.userRole.includes('IPC_TRAY_MANAGER')
                || this.props.userRole.includes('IPC_BAG_MANAGER')) && (
                <Button className="action-buttons" onClick={this.createRecalculateTask} style={{ margin: '10px' }}>
                  Create New Recalculation Task
                </Button>
              )}
              <div className="list-table-container" style={{ paddingBottom: '20px', minHeight: '740px' }}>
                <ListTable
                  listId={TableDefinitions.RECALCULATE_TASKS_LIST.id}
                  loading={isLoading}
                  columns={columns}
                  data={data}
                  pagination
                />
              </div>
            </div>
          )}
          {showCreateModal && (
            <RecalculateTasksCreate
              closeDialog={this.hideCreateFormModal}
              openDialog={this.showCreateFormModal}
              refreshTransactions={this.onCriteriaApply}
            />
          )}
        </div>
      </div>
    );
  }
}

RecalculateTasksContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  checkedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  isLoading: PropTypes.bool,
  globalStartDate: PropTypes.instanceOf(Date),
  setGlobalStartDateSelectionActionCreator: PropTypes.func,
  userRole: PropTypes.arrayOf(PropTypes.string),
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    checkedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    appContext: getAssetType(state),
    isLoading: getIsLoading(state),
    globalStartDate: getGlobalStartDate(state),
    userRole: getUserRole(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  setGlobalStartDateSelectionActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RecalculateTasksContainer);
